import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material';
import Login from './components/Login';
// import FileImport from './components/FileImport'; // O componente nÃ£o existe
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import Administracao from './components/Administracao';
import DeParaPanel from './components/admin/DeParaPanel';
import EmpresasPanel from './components/admin/EmpresasPanel';
import CategoriasPanel from './components/admin/CategoriasPanel';
import ResponsaveisPanel from './components/admin/ResponsaveisPanel';
import TiposAtendimentoPanel from './components/admin/TiposAtendimentoPanel';
import HistoricoResponsaveisPanel from './components/admin/HistoricoResponsaveisPanel';
import SubstituicoesResponsaveisPanel from './components/admin/SubstituicoesResponsaveisPanel';
import ComerciaisCorretorasPanel from './components/admin/ComerciaisCorretorasPanel';
import SeguradoorasPanel from './components/admin/SeguradoorasPanel';
import EmpresaSeguradoraPanel from './components/admin/EmpresaSeguradoraPanel';
import MetasPanel from './components/admin/MetasPanel';
import ComerciaisSeguradorasPanel from './components/admin/ComerciaisSeguradorasPanel';
import NovoUsuario from './components/NovoUsuario';
import AlterarSenha from './components/AlterarSenha';
import RegistrosNaoProcessados from './components/RegistrosNaoProcessados';
import RelatorioResultados from './components/RelatorioResultados';

// Atualizar o timestamp de atividade da aplicaÃ§Ã£o
// O localStorage jÃ¡ foi limpo pelo script em index.html
const APP_START_TIME = 'app_start_time';
const currentTime = Date.now();
localStorage.setItem(APP_START_TIME, currentTime.toString());

// DESABILITADO: Verificador de sessão que causava conflito com index.js
// Apenas o index.js gerencia verificação de sessão para evitar loops
const SessionChecker = () => {
  return null; // Componente desabilitado
};

const theme = createTheme({
  palette: {
    primary: {
      main: '#2196f3',
      light: '#64b5f6',
      dark: '#1976d2',
    },
    secondary: {
      main: '#f50057',
      light: '#ff4081',
      dark: '#c51162',
    },
    background: {
      default: '#f5f5f5',
      paper: '#ffffff',
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
    },
    h5: {
      fontWeight: 500,
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 12,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        },
      },
    },
  },
});

const PrivateRoute = ({ children }) => {
  // DESABILITADO COMPLETAMENTE: Apenas index.js gerencia autenticação

  return children;
};

// Rota privada específica para admins
const AdminRoute = ({ children }) => {
  // DESABILITADO COMPLETAMENTE: Apenas index.js gerencia autenticação

  return children;
};

// Rota especÃ­fica para alteraÃ§Ã£o de senha no primeiro acesso
const PrimeiroAcessoRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  const userData = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
  const primeiroAcesso = userData?.primeiro_acesso;
  
  // Se nÃ£o estiver logado, redirecionar para login
  if (!token) {
    return <Navigate to="/login" />;
  }
  
  // Se nÃ£o for primeiro acesso, redirecionar para dashboard
  if (!primeiroAcesso) {
    return <Navigate to="/dashboard" />;
  }
  
  return children;
};

const App = () => {
  const navigate = useNavigate();
  const [isCheckingAuth, setIsCheckingAuth] = useState(true);

  useEffect(() => {
    // DESABILITADO: Verificação redundante - causa conflito com index.js
    // Apenas o index.js gerencia verificação de sessão para evitar conflitos
  
    setIsCheckingAuth(false);
    return;
    
    // CÓDIGO ORIGINAL COMENTADO:
    /*
    // Verificar se estamos na pÃ¡gina de login
    const isLoginPage = window.location.pathname === '/login';
    
    // Se estamos na pÃ¡gina de login, nÃ£o precisamos verificar o token
    if (isLoginPage) {
      setIsCheckingAuth(false);
      return;
    }

    const checkAuth = async () => {
      const token = localStorage.getItem('token');
      if (!token) {
        console.log('Token nÃ£o encontrado, redirecionando para login...');
        localStorage.clear(); // Limpa todo o localStorage
        navigate('/login', { replace: true });
        return;
      }

      try {
        // Adicionar um parâmetro para evitar cache nas requisições
        const timestamp = new Date().getTime();
        const response = await axios.get(`${process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api')}/validate-token?t=${timestamp}`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        
        // Verificar explicitamente a resposta
        if (response.status === 200 && response.data.valid) {
          console.log('Token válido, mantendo sessão...');
        } else {
          console.warn('Resposta de validação de token invÃ¡lida:', response);
          localStorage.clear();
          navigate('/login', { replace: true });
        }
      } catch (error) {
        console.error('Erro ao validar token:', error);
        // Se houver qualquer erro (401, 403, etc), limpa o localStorage e redireciona
        localStorage.clear();
        navigate('/login', { replace: true });
      } finally {
        setIsCheckingAuth(false);
      }
    };

    checkAuth();
    */
  }, [navigate]);

  // Se estiver verificando autenticaÃ§Ã£o, nÃ£o renderiza nada
  if (isCheckingAuth) {
    return null;
  }

  return (
    <ThemeProvider theme={theme}>
      <SessionChecker />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/importacao" element={
          <PrivateRoute>
            <Dashboard />
          </PrivateRoute>
        } />
        <Route path="/relatorio-resultados" element={
          <PrivateRoute>
            <RelatorioResultados />
          </PrivateRoute>
        } />
        <Route
          path="/admin"
          element={
            <AdminRoute>
              <Administracao />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/usuarios"
          element={
            <AdminRoute>
              <AdminPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/empresas"
          element={
            <AdminRoute>
              <EmpresasPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/depara"
          element={
            <AdminRoute>
              <DeParaPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/categorias"
          element={
            <AdminRoute>
              <CategoriasPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/responsaveis"
          element={
            <AdminRoute>
              <ResponsaveisPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/tipos-atendimento"
          element={
            <AdminRoute>
              <TiposAtendimentoPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/comerciais-corretoras"
          element={
            <AdminRoute>
              <ComerciaisCorretorasPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/historico-responsaveis"
          element={
            <AdminRoute>
              <HistoricoResponsaveisPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/substituicoes-responsaveis"
          element={
            <AdminRoute>
              <SubstituicoesResponsaveisPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/seguradoras"
          element={
            <AdminRoute>
              <SeguradoorasPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/empresa-seguradora"
          element={
            <AdminRoute>
              <EmpresaSeguradoraPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/comerciais-seguradoras"
          element={
            <AdminRoute>
              <ComerciaisSeguradorasPanel />
            </AdminRoute>
          }
        />
        <Route
          path="/admin/metas"
          element={
            <AdminRoute>
              <MetasPanel />
            </AdminRoute>
          }
        />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route path="/dashboard" element={<Navigate to="/importacao" />} />
        <Route path="/novo-usuario" element={<AdminRoute><NovoUsuario /></AdminRoute>} />
        <Route path="/editar-usuario/:id" element={<AdminRoute><NovoUsuario /></AdminRoute>} />
        <Route path="/alterar-senha" element={<PrimeiroAcessoRoute><AlterarSenha /></PrimeiroAcessoRoute>} />
        <Route path="/registros-nao-processados/:id" element={<PrivateRoute><RegistrosNaoProcessados /></PrivateRoute>} />
        <Route path="*" element={<Navigate to="/importacao" />} />
      </Routes>
    </ThemeProvider>
  );
};

export default App;

